import localStorage from "@/storage/localStorage";
import cookie from "@/storage/cookies.js"
// 综合定位，优先取store、localStorage中缓存的定位信息，没有再获取高德定位，高德定位失败则获取百度定位
const def_pos = {
  lng: 116.405289,
  lat: 39.904987,
  address: { province: "北京" }
};
export function getPosition() {
  return new Promise(async (resolve, reject) => {
    if (cookie.cookieRead("area")) {
      let position = null;
        try {
          const AMap = AMap || window.AMap;
          position = await initBdMap();
          if (position && position.lng && position.lat) {
            return resolve(position);
          } else {
            return resolve(def_pos);
          }
        } catch (error) {
          return resolve(def_pos);
        }
    }
    let position = null;
    setTimeout(async () => {
      position = await initBdMap();
      if (position && position.lng && position.lat) {
        return resolve(position);
      } else {
        return resolve(def_pos);
      }
    }, 500);
  });
}
// 百度地图定位
export function initBdMap() {
  return new Promise((resolve, reject) => {
    let geolocation = new BMap.Geolocation();
    geolocation.getCurrentPosition(function(r) {
      if (this.getStatus() === BMAP_STATUS_SUCCESS) {
        // 获得成功
        let position = {
          lng: r.point.lng,
          lat: r.point.lat,
          checked:true,
          address: {
            province: r.address.province,
            city: r.address.city,
            district: r.address.district,
            street: r.address.street,
            streetNumber: r.address.street_number
          }
        };
        savePpostion(position);
        resolve(position);
      } else {
        reject();
        savePpostion(def_pos);
      }
    });
  });
}
// 保存定位的信息到store中和localStorage中
function savePpostion(position) {
  // this.$store.commit("SET_POSITION", position);
  localStorage.set("position", JSON.stringify(position));
}

